{
  "ACTIONS": {
    "CONFIRM": "Confirm",
    "CONTINUE": "Continue",
    "SUBMIT": "Submit",
    "RETRY": "Retry",
    "CANCEL": "Cancel",
    "EMPTY": "You have no orders",
    "LOADING_ORDERS": "Preparing Your Bill",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Update Cart",
    "EDIT": "Edit",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "This section is no longer available",
    "ITEM_NOT_FOUND": "This item is no longer available",
    "PROMOTION_NOT_AVAILABLE": "This promotion is no longer available",
    "REQUIRED": "Required",
    "COMBO": "Combo",
    "INVALID_EMAIL": "Please enter a valid email address",
    "INVALID_PHONE": "Please enter a valid phone number",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "Something went wrong loading this table. Please try again.",
    "TABLE_NOT_FOUND": "We couldn't find this table. Please rescan the QR code."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Last Name",
    "ROOM_NUMBER": "Room Number",
    "SNACKBAR_TITLE": "Your bill is on the way",
    "PAY_BILL": "Pay bill"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Total people on the table",
    "PAYING_FOR": "Total people you're paying for",
    "REMAINING": "Remaining amount",
    "CHEQUE": "Cheque",
    "AMOUNT_PAID": "Paid amount",
    "DISCOUNT": "Discount",
    "PROMO": "Promo",
    "FEES": "Fees",
    "PAID_ITEMS": "Paid items",
    "SPLIT_BILL": "Split Bill",
    "EDIT_SPLIT": "Edit Split",
    "PAY_BILL": "Pay Bill",
    "SPLIT_TITLE": "Split the bill",
    "SPLIT_SUBTITLE": "Select how you would like to split the bill",
    "SPLIT_EVENLY": "Split evenly",
    "CUSTOM_AMOUNT": "Custom Amount",
    "ADD_CUSTOM_AMOUNT": "Add Custom Amount",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Enter custom amount",
    "PAY_FOR_ITEMS": "Pay for your items",
    "CONFIRM_SELECTION": "Confirm Selection",
    "SOMEONE_ELSE_PAYING": "Someone else at your table is paying right now"
  },
  "COMBO": {
    "ADD_N": "Add {{count}} {{section}}",
    "REMOVE_N": "Remove {{count}} {{section}}",
    "CANNOT_PROCEED": "Please follow the guide above to complete your combo before continuing",
    "COMPLETE": "{{combo}} combo complete!",
    "ON_ANOTHER_SECTION": "This is part of your {{section}} combo"
  },
  "CART": {
    "TITLE": "Cart",
    "RECOMMENDATION": "You may also like",
    "TOTAL": "Total",
    "VIEW": "View cart & Place order",
    "EMPTY": "Empty",
    "PLACE_ORDER": "Place order",
    "ADD_TO_BILL": "Add to bill",
    "PAY_NOW": "Pay now",
    "OOPS": "Oops",
    "ADD_NEW_VARIANT": "Add another",
    "VARIANT_TITLE": "Changed your mind?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "Add a note",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "Payment",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Bill Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "My orders",
    "CONFIRMED": "Confirmed",
    "NOTES": "Add an order note",
    "TOTAL": "Total",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Order",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "Your Order Is Unpaid",
    "CANCELLED": "Your Order Has Been Cancelled",
    "VOID": "Your Order Has Been Voided",
    "UPDATED": "Your Order Has Been Updated",
    "ORDERS": "New Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "We'll be with you shortly",
    "HELP": "How can we help?",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "Skip",
    "MENU": "Menu",
    "SEARCH": "Search",
    "NO_SEARCH_RESULTS": "No items match your search",
    "SEARCH_OTHER_SECTIONS": "We found matches in other sections",
    "NO_FILTER_RESULTS": "No items match your filters",
    "CLEAR_FILTERS": "Clear filters",
    "NO_SECTIONS": "No sections available",
    "STAFF": "Call staff",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "LANGUAGE": "Language",
    "SELECT_LANGUAGE": "Select Language",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Charge to my room"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add Voucher",
    "PLACEHOLDER": "Enter Your Voucher",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "Tip",
    "ADD": "Add Tip",
    "PLACEHOLDER": "Enter Amount For Tip"
  },
  "LANDING": {
    "CALL_WAITER": "Call Waiter",
    "VIEW_BILL": "View bill - ",
    "LOADING_BILL": "Loading bill"
  },
  "LOADER": {
    "Heading": "Processing your payment...",
    "Subheading": "Please don’t close this page. We’re confirming your payment and will redirect you automatically.",
    "Hint": "This usually takes a few seconds."
  },
  "NoVoucher": "Voucher Not Available",
  "VoucherDisabled": "This voucher is disabled",
  "VoucherExpired": "This voucher has expired",
  "VoucherAlreadyUsed": "This voucher has already been used",
  "VoucherZeroBalance": "This voucher has a balance of 0",
  "VoucherUserLimitReached": "You have already used this voucher",
  "VoucherFirstOrderOnly": "This voucher is only for your first order",
  "VoucherNotApplicable": "This voucher does not apply to the items in your order"
}
